// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"464":"e52195dc","641":"b7cd7d8e","676":"1731fb89","836":"3ea1e47d","920":"fc17145b","986":"3ea1e47d"}[chunkId] + ".css";
};